import React, { useEffect, useRef, useState } from "react";
import "../css/layout.css";
import css from "../css/Profile.module.css";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import Rightcontainer from "../Components/Rightcontainer";
import Swal from "sweetalert2";
import Modal from "react-bootstrap/Modal";
import "../css/kyc.css";
import "../css/Loader.css";
import findGif from "../css/loading_old.gif";
import { useContext } from "react";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../store/allApi";

const Profile1 = ({ profile }) => {
  // language
  const translations = {
    hi: {
      wallet: "वॉलेट",
      refer: "किसी  मित्र का रेफर कोड इस्तेमाल करे | ",
      win: "पैसा जिता | ",
      game: "गेम खेला | ",
      referEarn: "रेफरल कमाई  ",
      referPerson: "आमंत्रित किये दोस्त | ",
    },
    en: {
      wallet: "My Wallet",
      refer: "Use Refer Code",
      Win: "Coin Won",
      game: "Battle Played",
      referEarn: "Referral Earning",
      referPerson: "Referred Players",
    },
  };

  const { language } = useContext(LanguageContext);

  // BASE URL

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  // alert(baseUrl)
  // +++++++++++++++++++++++++++++
  const [show, setShow] = useState(false);

  const [show1, setShow1] = useState(false);

  const handleClose = () => setShow1(false);
  const handleShow = () => {
    setShow1(true);
  };

  const [referral, setCode] = useState("");
  const [Id, setId] = useState(null);
  const [msg, setMsg] = useState("");

  // const [profile, setProfile] = useState();
  const [portcss, setPortcss] = useState(css.active_tab);
  const [portcss1, setPortcss1] = useState(css.inactive_tab);
  const [crushcss, setCrushcss] = useState(true);
  const [holder_name, setHolder_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [isLoading, setIsloading] = useState(false);

  // KYC MODEL

  const [showKyc, setShowKyc] = useState(false);
  const [kycTab, setKycTab] = useState("online"); // online | offline
  const [showBottom, setShowBottom] = useState(false);
  const [process1, setProcesss] = useState(false);

  const udata = localStorage.getItem("udata");
  const profileData = (() => {
    try {
      return JSON.parse(udata || "null");
    } catch (e) {
      return null;
    }
  })();
  const [SData, setSData] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("sitSetting") || "null");
    } catch (e) {
      return null;
    }
  });
  const onlineKYC = Boolean(SData?.onlineKYC);
  const offlineKYC = Boolean(SData?.offlineKYC);
  const kycEnabled = onlineKYC || offlineKYC;

  const handleCloseBottom = () => setShowBottom(false);
  const handleShowBottom = (data) => {
    setShowBottom(true);
  };
  const handleCloseKyc = () => {
    setShowKyc(false);
  };
  const handleShowKyc = () => setShowKyc(true);

  const openKycModal = () => {
    if (onlineKYC && !offlineKYC) setKycTab("online");
    else if (!onlineKYC && offlineKYC) setKycTab("offline");
    else setKycTab("online");
    setShowKyc(true);
  };
  const [inputOpen, setInputOpen] = useState(false);
  const [Email, setEmail] = useState();

  const toggleInput = () => {
    setInputOpen(!inputOpen);
  };

  const history = useHistory();

  const logout = async () => {
    localStorage.clear();

    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // axios
    //   .get(baseUrl + `me`, { headers })

    const res = await apiRequest(`me`, "GET", null, headers)
      .then((res) => {
        if (res.data) {
        }
      })
      .catch((e) => {
        if (e.response.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("token");
          window.location.reload();
          history.push("/login");
        }
      });
  };

  //Update email

  const UpdateEmail = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (Email != null) {
      try {
        const respone = await apiRequest(
          `user/profile/edit`,
          "PATCH",
          { Email },
          headers
        );
        if (respone.data.status == false) {
          Swal.fire({
            title: respone.data.msg,
            icon: "error",
            confirmButtonText: "OK",
          });
        } else {
          setEmail(respone?.data?.user?.Email);
          setInputOpen(false);
          Swal.fire({
            title: respone.data.msg,
            icon: "Success",
            confirmButtonText: "OK",
          });
          // UserALL();
        }
      } catch (error) {}
    } else {
      Swal.fire({
        title: "Please enter your Email",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // name Update
  const [Name, setName] = useState();

  const UpdateProfile = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (Name != null) {
      const respone = await apiRequest(
        `user/profile/edit`,
        "PATCH",
        { Name },
        headers
      );
      if (respone.data.status == false) {
        Swal.fire({
          title: respone.data.msg,
          icon: "error",
          confirmButtonText: "OK",
        });
      } else {
        setName(respone?.data?.user?.Name);
        Swal.fire({
          title: respone.data.msg,
          icon: "Success",
          confirmButtonText: "OK",
        });
        // UserALL();
      }
    } else {
      Swal.fire({
        title: "Please enter your Name",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  const updateBankDetails = async (e) => {
    e.preventDefault();
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    let alldata = {
      holder_name,
      account_number,
      ifsc_code,
      upi_id,
    };
    const res = await apiRequest(
      `user/profile/edit`,
      "PATCH",
      alldata,
      headers
    );

    if (res.data.status == false) {
      setShow((prev) => !prev);
      // UserALL();
      let message;
      message = res.data.msg;
      if (!res.data.msg) {
        message = "something went wrong";
      }
      Swal.fire({
        title: message,
        icon: res.data.submit ? "success" : "error",
        confirmButtonText: "OK",
      });
    }
    // });
  };
  const update_RefCode = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    if (referral != null) {
      const data = await axios
        .patch(
          baseUrl + `/user/profile/edit`,
          {
            referral,
          },
          { headers }
        )
        .then((res) => {
          console.log(res);
          if (res.data.submit == false) {
            Swal.fire({
              title: res.data.msg,
              icon: "error",
              confirmButtonText: "OK",
            });
          } else {
            Swal.fire({
              title: res.data.msg,
              icon: "success",
              confirmButtonText: "OK",
            });
          }
        });
    } else {
      Swal.fire({
        title: "Invalid referral code",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  //// total game
  const [total, setTotal] = useState();
  const TotalGame = async (Id) => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `total/user/all/${userId}`,
        "GET",
        null,
        headers
      );
      if (res.data) {
        setTotal(res.data);
      }
    } catch (e) {}
  };

  const [pic, setPic] = useState();
  const Result = async (file) => {
    if (file) {
      const access_token = localStorage.getItem("token");

      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const formData = new FormData();
      formData.append("avatar", file);

      // await fetch(baseUrl+`users/me/avatar`, {
      //   method: "POST",
      //   body: formData,
      //   headers,
      // })
      const res = await apiRequest(
        `users/me/avatar`,
        "POST",
        formData,
        headers
      );
      // .then((res) => {});
    }
  };
  //avatar

  useEffect(() => {
    const applySettings = () => {
      try {
        setSData(JSON.parse(localStorage.getItem("sitSetting") || "null"));
      } catch (e) {
        setSData(null);
      }
    };
    window.addEventListener("sitSetting", applySettings);
    return () => window.removeEventListener("sitSetting", applySettings);
  }, []);

  const Kyc = () => {
    if (profile?.verified === "pending") {
      Swal.fire({
        icon: "info",
        title: "KYC In Process",
        text: "Your KYC is under review. Please wait for admin verification.",
      });
      return;
    }
    if (profile?.verified === "verified") {
      Swal.fire({
        icon: "success",
        title: "Already verified",
        text: "Your KYC is already verified.",
      });
      return;
    }
    openKycModal();
  };

  // AADHAR API

  const [AadharNum, setAadharNum] = useState("");
  const [userAdharData, setUserAdharData] = useState("");
  const handleAdharChnage = (e) => {
    setAadharNum(e.target.value);
  };

  const AdharNumber = async (e) => {
      setIsloading(true);
      e.preventDefault();
  
      // Ensure AadharNum is a 12-digit number before making the API call
      if (/^[0-9]{12}$/.test(AadharNum)) {
        const access_token = localStorage.getItem("token");
        const headers = {
          Authorization: `Bearer ${access_token}`,
        };
  
        const data = {
          aadharNumber: AadharNum,
        };
        try {
          const res = await apiRequest("aadharcard-auto", "POST", data, headers);
          setUserAdharData(res?.data);
          setIsloading(false);
  
          if (res.data.status === false) {
            Swal.fire({
              icon: "error",
              title: "KYC",
              text: res?.data?.msg || "Unable to start KYC verification",
            });
          } else {
            const otpMsg =
              res?.data?.msg ||
              res?.data?.data?.message ||
              res?.data?.data?.data?.message ||
              "OTP sent to your registered mobile number";
            Swal.fire({
              icon: "success",
              title: "OTP sent",
              text: otpMsg,
            });
          }
        } catch (error) {
          setIsloading(false);
          Swal.fire({
            icon: "error",
            title: "KYC request failed",
            text:
              error?.response?.data?.msg ||
              error?.response?.data?.message ||
              error?.message ||
              "Something went wrong",
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Invalid Aadhar Number",
          text: "Please enter a valid 12-digit Aadhar number.",
        });
        setIsloading(false);
      }
    };
  
    const AdharOtp = async (e) => {
      setIsloading1(true);
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };
      const data = {
        aadharNumber: AadharNum,
        otp: AadharOtp,
        transaction_id: userAdharData.data?.ref_id,
      };
  
      try {
        const res = await apiRequest(
          `aadharcard-auto-verify`,
          "POST",
          data,
          headers,
        );
        setKycdata(res.data);
        setVerifyData(res.data);
        setIsloading1(false);
  
        if (res.data.status === false) {
          if (res.data?.msg) {
            setMsg(res.data?.msg);
          } else {
            setMsg(res.data?.message);
          }
        } else {
           setShowKyc(false);
          // handleCloseKyc();
          history.push("/Home");
          window.location.reload();
  
        }
      } catch (e) {
        console.log(e);
      }
    };

  const [AadharOtp, setAadharOtp] = useState("");
  const [verifyData, setVerifyData] = useState("");
  const [kycdata, setKycdata] = useState();
  const [isLoading1, setIsloading1] = useState(false);

  const handleAdharOtpChnage = (e) => {
    setAadharOtp(e.target.value);
  };

  // DOCUMENTATION API START

  let aadharProcess = useRef(false);

  const [Names, setNames] = useState("");
  const [DOB, setDob] = useState("");
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);

  const handleSubmitdata = async (e) => {
    e.preventDefault();

    if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
      alert("Please fill in all fields and upload both images.");
      return;
    }
setIsloading(true);
console.log(aadharProcess,'aadharProcess')
    if (aadharProcess.current === false) {
      setProcesss(true);
      aadharProcess.current = true;

      const formData = new FormData();
      formData.append("Name", Names);
      formData.append("DOB", DOB);
      formData.append("front", frontLoaded[0]);
      formData.append("back", backLoaded[0]);
      formData.append("Number", AadharNum);
      formData.append("Email", Email);

      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      // axios
      //   .post(baseUrl+`aadharcard`, formData, {
      //     headers,
      //   })
      const res = await apiRequest(`aadharcard`, "POST", formData, headers);
      // .then((res) => {
      console.log(res.data,'response');
      setIsloading(false);
      if (res.data.verified == "pending") {
 Swal.fire({
          title: "Your KYC form submitted. Wait for Verify",
          icon: "success",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            handleCloseKyc();
                window.location.reload();
          }
        });
      }
      else if (res.data?.status === false) {
        Swal.fire({
          title: res.data.msg,
          icon: "error",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            handleCloseKyc();
          }
        });
      } else if (res.data?.msg === "Duplicate Entity") {
        Swal.fire({
          title: "Duplicate Entity",
          icon: "error",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            handleCloseKyc();
          }
        });
      } else {
        Swal.fire({
          title: "Your KYC form submitted",
          icon: "success",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            handleCloseKyc();
          }
        });
        history.push("/Profile");
      }

      aadharProcess.current = false;
      setProcesss(false);
      setIsloading(false);
      // })
      // .catch((error) => {
      //   console.error(error);
      //   if (error.response && error.response.status === 401) {
      //     localStorage.removeItem("token");
      //     window.location.reload();
      //     history.push("/login");
      //   }
      // });
    } else {
      setIsloading(false);
      aadharProcess.current = false;
      alert("Your last request on process.  Please wait for update");
    }
  };

  useEffect(() => {
    // UserALL();
    TotalGame();
  }, []);

  // Email validations
  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const isValidFormat = emailRegex.test(newEmail);

    const endsWithCom = newEmail.toLowerCase().endsWith(".com");

    setIsValidEmail(isValidFormat && endsWithCom);
  };

  // change theme
  const theme = localStorage.getItem("theme");
  const styles = {
    backgroundColor: theme === "light" ? "#fff" : "black",
    color: theme === "light" ? "black" : "#fff",
  };

  return (
    <>
      {/* <Header user={profile} /> */}
      {
        <div
          className="leftContainer mb_space"
          style={{  height: "124% !important" }}
        >
          <div className={css.profilePageNew}>
             <div className={css.profileHeroCard}>
    
              {/* Profile Content */}
              <div className={css.profileHeroContent}>
                {/* Avatar */}
                <label className={css.profileAvatarWrap}>
        <input type="file" className="d-none" accept="image/*" onChange={(e) => Result(e.target.files[0])} />
        <img
          src={profileData?.avatar ? `${baseUrl}/${profileData.avatar}` : "/images/avatars/Avatar1.png"}
          className={css.profileAvatarImg}
          alt="Profile"
        />
        <span className={css.profileAvatarEdit}>Edit</span>
        {profile?.verified === "verified" && <span className={css.profileVerifiedDot}></span>}
      </label>

      {/* Name Section */}
      <div className={css.profileHeroInfo}>
        <h2 className="text-white font-w700 mb-0">
          {profile?.Name}{" "}
          {profile?.verified === "verified" }
          <img
            src="/images/icon-edit.jpg"
            className={css.profileEditIcon}
            alt="Edit"
            onClick={() => {
              setPortcss(css.inactive_tab);
              setPortcss1(css.active_tab);
            }}
          />
        </h2>

        {/* Contact Info */}
        <div className="d-flex align-items-center refrer-box mt-2">
          <div className={css.profileContactContent}>
            <h6 className="text-white font-w700 mb-0">{profile?.Phone}</h6>
          </div>
        </div>
        <div className="d-flex align-items-center refrer-box mt-2">
          <div className={css.profileContactContent}>
            <h6 className="mb-0">{profile?.Email || "Update Your Email"}</h6>
          </div>
          <div className="ml-auto" style={{ cursor: "pointer" }}>
            {/* <img src="/images/icon-edit.jpg" className="edit-icon" alt="" onClick={toggleInput} /> */}
          </div>
        </div>

        {/* Editable Name Input */}
        <div className={`${css.profileEditBox} ${portcss1}`}>
          <input
            type="text"
            maxLength="20"
            placeholder="Enter Username"
            value={Name}
            onChange={(e) => setName(e.target.value)}
          />
          <img
            src="/images/select-blue-checkIcon.png"
            className={css.profileSaveIcon}
            alt="Save"
            onClick={() => {
              setPortcss(css.active_tab);
              setPortcss1(css.inactive_tab);
              UpdateProfile(Id);
            }}
          />
        </div>
      </div>
              </div>

              {/* EMAIL */}

              <div>
                {/* MODEL OF KYC  */}
                <Modal
                  show={showKyc}
                  onHide={handleCloseKyc}
                  className="kyc-verify-modal"
                  dialogClassName="kyc-verify-dialog"
                  contentClassName="kyc-verify-content"
                  aria-labelledby="kyc-modal-title"
                  centered
                >
                  <Modal.Header closeButton className="kyc-verify-header">
                    <Modal.Title id="kyc-modal-title">KYC Verification</Modal.Title>
                  </Modal.Header>
                  <Modal.Body className="kyc-verify-body">
                    <div
                      className={`kyc-type-switch ${
                        (onlineKYC || !kycEnabled) && (offlineKYC || !kycEnabled)
                          ? "kyc-type-switch--dual"
                          : "kyc-type-switch--single"
                      }`}
                      role="tablist"
                    >
                      {(onlineKYC || !kycEnabled) && (
                        <button
                          type="button"
                          role="tab"
                          aria-selected={kycTab === "online"}
                          className={`kyc-type-btn ${kycTab === "online" ? "is-active" : ""}`}
                          onClick={() => setKycTab("online")}
                        >
                          Online KYC
                        </button>
                      )}
                      {(offlineKYC || !kycEnabled) && (
                        <button
                          type="button"
                          role="tab"
                          aria-selected={kycTab === "offline"}
                          className={`kyc-type-btn ${kycTab === "offline" ? "is-active" : ""}`}
                          onClick={() => setKycTab("offline")}
                        >
                          Offline KYC
                        </button>
                      )}
                    </div>

                    {kycTab === "online" && (onlineKYC || !kycEnabled) && (
                      <div className="kyc-form-stack">
                        <label className="kyc-field-label">Aadhaar number</label>
                        <input
                          type="tel"
                          inputMode="numeric"
                          maxLength={12}
                          className="kyc-field-input"
                          value={AadharNum}
                          placeholder="12-digit Aadhaar number"
                          onChange={handleAdharChnage}
                        />
                        {msg ? <p className="kyc-field-hint">{msg}</p> : null}

                        {isLoading ? (
                          <div className="kyc-loading">
                            <img src={findGif} alt="Loading" />
                          </div>
                        ) : userAdharData?.status !== true ? (
                          <button
                            type="button"
                            className="kyc-action-btn"
                            onClick={AdharNumber}
                          >
                            Send OTP
                          </button>
                        ) : (
                          <>
                            <label className="kyc-field-label">Enter OTP</label>
                            <input
                              type="tel"
                              inputMode="numeric"
                              className="kyc-field-input"
                              value={AadharOtp}
                              placeholder="OTP"
                              onChange={handleAdharOtpChnage}
                            />
                            {isLoading1 ? (
                              <div className="kyc-loading">
                                <img src={findGif} alt="Loading" />
                              </div>
                            ) : (
                              <button
                                type="button"
                                className="kyc-action-btn"
                                onClick={AdharOtp}
                                disabled={isLoading1}
                              >
                                Submit OTP
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    )}

                    {kycTab === "offline" && (offlineKYC || !kycEnabled) && (
                      <div className="kyc-form-stack">
                        <label className="kyc-field-label">Full name</label>
                        <input
                          type="text"
                          className="kyc-field-input"
                          value={Names}
                          placeholder="Name as on Aadhaar"
                          onChange={(e) => setNames(e.target.value)}
                        />
                        <label className="kyc-field-label">Aadhaar number</label>
                        <input
                          type="tel"
                          inputMode="numeric"
                          maxLength={12}
                          className="kyc-field-input"
                          value={AadharNum}
                          placeholder="12-digit Aadhaar number"
                          onChange={handleAdharChnage}
                        />
                        <label className="kyc-field-label">Email</label>
                        <input
                          type="email"
                          className="kyc-field-input"
                          value={Email}
                          placeholder="Email address"
                          onChange={handleEmailChange}
                        />
                        <label className="kyc-field-label">Date of birth</label>
                        <input
                          type="date"
                          className="kyc-field-input"
                          value={DOB}
                          onChange={(e) => setDob(e.target.value)}
                        />
                        <label className="kyc-field-label">Aadhaar front</label>
                        <input
                          className="kyc-field-input kyc-file-input"
                          id="frontPhoto"
                          name="frontPhoto"
                          type="file"
                          onChange={(e) => setFrontLoaded(e.target.files)}
                          accept="image/*"
                          required
                        />
                        <label className="kyc-field-label">Aadhaar back</label>
                        <input
                          id="backPhoto"
                          name="backPhoto"
                          type="file"
                          accept="image/*"
                          onChange={(e) => setBackLoaded(e.target.files)}
                          className="kyc-field-input kyc-file-input"
                          required
                        />
                        <button
                          type="button"
                          className="kyc-action-btn"
                          onClick={handleSubmitdata}
                        >
                          Submit documents
                        </button>
                      </div>
                    )}
                  </Modal.Body>
                  <Modal.Footer className="kyc-verify-footer">
                    <button
                      type="button"
                      className="kyc-secondary-btn"
                      onClick={handleCloseKyc}
                    >
                      Close
                    </button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>

          
          {/* cash won small box */}
          <div className={css.profileStatsSection}>
        <div className="row rows">
          <div className="col-6 col-sm-6 pl-0">
            <div className={`${css.profileStatTile} ${css.profileStatBlue}`}>
              <div className={css.profileStatIcon}>
                <img src="/images/refer.png" alt="" />
              </div>
              <div className={css.profileStatText}>
                <h3 className="text-white">Referral Earnings</h3>
                <h4 className="text-white">{profile?.referral_earning}</h4>
              </div>
            </div>
          </div>

          <div className="col-6 col-sm-6">
            <div className={`${css.profileStatTile} ${css.profileStatPurple}`}>
              <div className={css.profileStatIcon}>
                <img src="/images/Battle.png" alt="" />
              </div>
              <div className={css.profileStatText}>
                <h3 className="text-white">Games Played</h3>
                <h4 className="text-white">{total}</h4>
              </div>
            </div>
          </div>

          <div className="col-6 col-sm-6 mt-3 pl-0">
            <div className={`${css.profileStatTile} ${css.profileStatGreen}`}>
              <div className={css.profileStatIcon}>
                <img src="/images/Coinw.png" alt="" />
              </div>
              <div className={css.profileStatText}>
                <h3 className="text-white">Coins Won</h3>
                <h4 className="text-white">{profile?.wonAmount}</h4>
              </div>
            </div>
          </div>

          <div className="col-6 col-sm-6 mt-3">
            <div className={`${css.profileStatTile} ${css.profileStatGold}`}>
              <div className={css.profileStatIcon}>
                <img src="/images/withdreaa.png" alt="" />
              </div>
              <div className={css.profileStatText}>
                <h3 className="text-white">Total Withdrawal</h3>
                <h4 className="text-white">{profile?.totalWithdrawl}</h4>
              </div>
            </div>
          </div>
        </div>

        {/* KYC Button */}
        <div className={css.profileKycWrap}>
          {profile?.verified === "verified" ? (
            <div className={`${css.profileKycCard} ${css.profileKycVerified}`}>
              <img src="/images/avatars/Avatar1.png" alt="" height="35"/>
              <span>KYC Successfully Verified</span>
            </div>
          ) : (
            <div
              className={css.profileKycCard}
              onClick={Kyc}
              style={{ cursor: "pointer" }}
            >
              <img src="/images/avatars/Avatar1.png" alt=""  height="35"/>
              <span>
                {profile?.verified === "pending" ? "KYC In Process" : "KYC Verification"}
              </span>
            </div>
          )}
        </div>

        <div className={css.profileLogoutWrap}>
          <Link
            to="/login"
            className={css.profileLogoutButton}
            onClick={(e) => logout(e)}
          >
            Log Out
          </Link>
        </div>
      </div>
        </div>
      }

      <div className="rightContainer">
        <Rightcontainer />
      </div>
      {/* <ModalProfile style3={
                profileModalstyle
            } Enter={Enter}/> */}
      <div className={css.kyc_select} id="profileModal">
        <div className={css.overlay} />
        <div
          className={`${css.box}`}
          style={{
            bottom: "0px",
            position: "absolute",
          }}
        >
          <div className={css.bg_white}>
            <div className={`${css.header} ${css.cxy} ${css.flex_column}`}>
              <picture>
                <img
                  height="80px"
                  width="80px"
                  src="/images/avatars/Avatar7.png"
                  alt=""
                />
              </picture>
              <div className={`${css.header_text} mt-2`}>Choose Avatar</div>
            </div>
            <div className="mx-3 pb-3" style={{ paddingTop: "200px" }}>
              <div className="row justify-content-between col-10 mx-auto">
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar1.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar7.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar3.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar4.png"
                  alt=""
                />
              </div>
              <div className="row justify-content-between col-10 mx-auto mt-3">
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar5.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar6.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar7.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar8.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Profile1;
